import Cookies from "js-cookie";
import deparam from "jquery-deparam";

$(() => {
  $("#reset_hooper").on("click", () => {
    const articleURL = location.href.replace(location.search, "");
    const $button = $("#reset_hooper");
    const originalText = $button.html();

    $button.html("Resetting...");

    $.ajax({
      crossDomain: true,
      type: "POST",
      url: `${articleURL}/reset`
    })
      .done(function (_data, _textStatus, _jqXHR) {
        alert("Hooper was successfully reset");
      })
      .fail(function (_jqXHR, _textStatus, _errorThrown) {
        alert("Something went wrong resetting hooper");
      })
      .always(function () {
        $button.html(originalText);
      });
  });

  $("#purge_cloudflare").on("click", async () => {
    const url = window.location.href;
    const csrfToken = document
      .querySelector('meta[name="csrf-token"]')
      .getAttribute("content");

    try {
      const response = await fetch("/admin/purge_cloudflare", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-CSRF-Token": csrfToken
        },
        body: JSON.stringify({ url: url })
      });

      const result = await response.json();

      if (!result.errors) {
        alert(result.message);
      } else {
        console.error("Cache clear failure:", result.errors[0].message);
        alert("Failed to clear cache. Check console for errors.");
      }
    } catch (error) {
      console.error("Cache clear error: ", error);
      alert("An unknown error occurred.");
    }
  });
});
